<template>
  <div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card >
            <v-card-title>
              <span> Initiate Route Confirmation </span>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1" 
                text 
                @click="edit()"
              >
                Edit
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="12" sm="6" md="7">
                        <span><b>TRACER#:</b> <b>{{ document.transaction_id}}</b></span>
                    </v-col>
                    <v-col cols="6" md="5">
                        <span><b>Date:</b> {{ document.date }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <span><b>Subject:</b> {{ document.subject}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pt-0">
                        <span><b>Document Type:</b> {{ document.document_type ? document.document_type.name : ""}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <span><b>Sender:</b> {{ document.sender}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pt-0">
                        <span><b>Receiver/s:</b> 
                            <span v-for="(item, index) in addedReceivers" :key="item.index">{{item.user.name}}<span v-if="index < addedReceivers.length - 1">, </span></span>
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <span><b>Document:</b> <a style="text-decoration:none" :href="file_url" target="_blank">{{document.filepath_url}}</a></span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <span><b>Added by:</b> {{loggedInUserName}}</span>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions style="padding-right: 24px; padding-bottom:16px">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="initiateToRouteRequest()"
                >Initiate</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
    <UpdateDocument 
      :dialog="updateDialog"
      :isStandalone="true"
      @closeDialog="closeUpdateDialog"
      :document="document"
      :addedReceivers="addedReceivers"
    />
  </div>
</template>

<script>
import { fileSystemUrl } from '../../../config/config.json'
import { mapActions, mapGetters } from "vuex"
import LoadingOverlay from "../../common/LoadingOverlay.vue";
import UpdateDocument from "./UpdateDocuments.vue"
import Swal from "sweetalert2";
export default {
  name: "DocumentTypeModal",
  props: {
    dialog: Boolean,
    document: Object,
    addedReceivers: Array
  },
  components: {
    LoadingOverlay,
    UpdateDocument
  },
  data() {
    return {
      updateDialog: false,
      loading: false,
      details: "",
      updateItem: null,
      selected: [],
      file_url: ""
    };
  },
  computed: {
    ...mapGetters(["loggedInUserName"]),
  },
  methods: {
    ...mapActions(["fetchRejectedDocuments","attachDocuments", "clearReceivers", "initiateDocumentRouteRequest", "fetchPendingInitiateDocuments"]),
    close() {
      this.details = "";
      this.$emit("closeDialog", false);
      this.selected = []
      this.loading = false;
      this.clearReceivers();
    },
    closeUpdateDialog() {
      this.updateDialog = false;
      this.close()
    },
    edit() {
      this.updateDialog = true;
    },
    initiateToRouteRequest() {
        let transaction_document = this.document;
        Swal.fire({
          title: "Confirm Action",
          text: `Document has been requested to initiate to route. \n Tracer No:${transaction_document.transaction_id} \nSubject: ${transaction_document.subject}`,
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "##1A76D2",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirm",
        }).then((result) => {
          if (result.isConfirmed) {  
            this.loading = true;
            this.initiateDocumentRouteRequest(this.document).then(() => {
                this.fetchPendingInitiateDocuments().then(()=> {
                  this.fetchRejectedDocuments().then(()=> {
                    this.close();
                    Swal.fire(
                      "Done!",
                      "Document has been requested to initiate to route.",
                      "success"
                    );
                  })
                })
                
            });
          }
        });
    }
  },
  watch: {
      dialog: {
        handler() {
            this.file_url = `${fileSystemUrl}/view/${this.document.filepath_url}`
        },
      }, 
  },
};
</script>

<style>
</style>